import {css} from 'styled-components';

export const SizeVariable = css`
    --aside-width-small: 300px;
    --aside-width-medium: 400px;
    --aside-width-large: 550px;
    --aside-width-extra-large: 800px;

    --footer-height-small: 200px;
    --footer-height-medium: 300px;
    --footer-height-large: 420px;

    --aside-width: var(--aside-width-medium);
    --footer-height: var(--footer-height-medium);

    --aside-width-screen-tablet: 220px;
    --aside-width-screen-tablet-lg: 300px;
    --aside-width-screen-tablet-xl: 400px;
    --aside-width-screen-tablet-xxl: 600px;

    @media (max-width: 1860px) {
        --aside-width-extra-large: var(--aside-width-screen-tablet-xxl);
    }

    @media (max-width: 1680px) {
        --aside-width-extra-large: var(--aside-width-screen-tablet-xl);
    }

    @media (max-width: 1240px) {
        --aside-width-small: var(--aside-width-screen-tablet);
        --aside-width-medium: var(--aside-width-screen-tablet);
        --aside-width-large: var(--aside-width-screen-tablet);
        --aside-width-extra-large: var(--aside-width-screen-tablet-lg);
    }
`;

export const AsideSizeSetup = css`
    &.sm {
        --aside-width: var(--aside-width-small);
    }
    &.lg {
        --aside-width: var(--aside-width-large);
    }
    &.xl {
        --aside-width: var(--aside-width-extra-large);
    }
`;

export const FooterSizeSetup = css`
    &.sm {
        --footer-height: var(--footer-height-small);
    }
    &.lg {
        --footer-height: var(--footer-height-large);
    }
`;
